import type { FC } from "react";

import { CardImplementationSearchForm } from "src/app/features/CardImplementation/components/forms/CardImplementationSearchForm";
import { CardImplementationsTable } from "src/app/features/CardImplementation/components/tables/CardImplementationsTable";
import type { CardImplementationList } from "src/app/features/CardImplementation/types/CardImplementationList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const CardImplementationsPage: FC<NoneOwnProps> = () => {
    const table = <CardImplementationsTable />;
    const searchForm = <CardImplementationSearchForm />;
    const hasAccess = canAccess(ResourceName.CARD_IMPLEMENTATIONS, "canRead");

    return (
        <PageLayout name="cardImplementations_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.cardImplementations" />
                    <ResourceManager<CardImplementationList>
                        useDataGroup
                        dataMapperKey="cardImplementationsTableData"
                        resource={ResourceName.CARD_IMPLEMENTATIONS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
